import { ChartInfo } from './chart-info'

export default ChartInfo
